import axios from 'axios';
import {
    MobileOrientation
} from 'mobile-orientation'

import device from "current-device";
import {
    page
} from 'vue-analytics';

import moment from 'moment';
import store from "./../store";

export default {
    data: function () {
        return {

            buildVersion: "1.53",
            headers: {
                Authorization: "cHJpdl85OWFlMDY1MjUwMmRjYzJkMDc1MzYxZDk3YjJmMjRjNQ",
                token: "Sf2eIeDGZihGSEgh7hv5"
            },
            debug: true,
            localhost: false,
            test: true,
            loggedIn: false,
            plans: [],
            isMobile: false,
            coreData: null,
            currentCustomer: null,
            orientation: new MobileOrientation({
                withTouch: true
            }),
            publicPath: process.env.BASE_URL,
            baseFunctionUrl: this.localhost ? "http://localhost:7071/api/" : this.test ? "https://additbookingfunctions.azurewebsites.net/api/" : "https://additbookingfunctions.azurewebsites.net/api/", // "https://functions.dryk.dk/api/",
            // DATA


        }
    },
    filters: {
        cleanCurrency(value) {
            if (value == null || value == undefined) return "";
            value = value.toFixed(2);
            return value.replace('.', ',');
        },

        formatCurrency(value) {
            if (value == null || value == undefined) return "";
            value = value.toFixed(2);
            return "Kr. " + value.replace('.', ',');
        },
        reepayCurrency(value) {
            if (value == null || value == undefined) return "";
            value = (value / 100).toFixed(2);
            return "Kr. " + value.replace('.', ',');
        },

        fullDateTime(value) {
            if (value == null || value == undefined) return "";
            value = moment(value).format('DD-MM-YYYY HH:mm');
            return value;
        },
        fullDateTimeWithKl(value) {
            if (value == null || value == undefined) return "";
            value = moment(value).format('DD-MM-YYYY') + ' kl. ' + moment(value).format('HH:mm');
            return value;
        },
        /**
         * Converts a day number to a string.
         *
         * @param {Number} dayIndex
         * @return {String} Returns day as string
         */
        dayOfWeekAsString(dayIndex) {
            return ["0", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"][dayIndex] || '';
        }


    },
    beforeDestroy() {
        this.orientation.destroy()
    },
    created: function () {
        this.isMobile = device.mobile();
        this.baseFunctionUrl = this.localhost ? "http://localhost:7071/api/" : this.test ? "https://additbookingfunctions.azurewebsites.net/api/" : "https://additbookingfunctions.azurewebsites.net/api/",
            console.log(this.baseFunctionUrl);

        axios.interceptors.request.use(
            (config) => {
                // let token = localStorage.getItem('authtoken');

                //if (token) {
                //  config.headers['Authorization'] = `Bearer ${ token }`;
                config.headers['Authorization'] = this.headers.Authorization
                config.headers['token'] = this.headers.token;

                return config;
            },

            (error) => {
                return Promise.reject(error);
            }
        );

        this.getCenters();

    },

    computed: {
        isPortrait() {
            return this.orientation.isPortrait
        },
        isLandscape() {
            return this.orientation.isLandscape
        }
    },
    methods: {
        tracking: function (code) {
            code = '/' + code;
            page(code);
            /*eslint no-undef: 1*/
            fbq('track', code);
            /*eslint no-undef: 0*/
        },

        isAdmin() {

            if (this.$store.getters.currentUser === null) return false;
            return this.$store.getters.currentUser.roles == 'Admin'
        },
        isSuperAdmin() {

            if (this.$store.getters.currentUser === null) return false;
            return (this.isAdmin() && this.$store.getters.currentUser.email == 'jan@hjordie.dk')
        },
        isCenterAdmin() {

            if (this.$store.getters.currentUser === null) return false;
            if (this.$store.getters.currentUser.roles == 'CenterAdmin' && this.$store.getters.currentCenter) {
                var res = (this.$store.getters.currentUser.editorForCenters.includes(this.$store.getters.currentCenter.rowKey));

                return res;
            } else return false;
        },
        isUser() {
            if (this.$store.getters.currentUser === null) return false;
            return this.$store.getters.currentUser.roles == 'User'
        },
        fetchAllCenters: function () {
            return axios.get(this.baseFunctionUrl + "GetAllCenters").then((res) => {
                return res.data;
            })
        },
        fetchVisibleCenters: function () {
            return axios.get(this.baseFunctionUrl + "GetVisibleCenters").then((res) => {
                return res.data;
            })
        },
        serviceCreateCenter: function () {
            return axios.post(this.baseFunctionUrl + "CreateCenter").then((res) => {
                return res.data;
            })
        },
        fetchCenter: function (id) {
            return axios.get(this.baseFunctionUrl + "GetCenter/" + id).then((res) => {
                return res.data;
            })
        },
        addUpdateCenter: function (center) {
            return axios.post(this.baseFunctionUrl + "AddUpdateCenter/", center).then((res) => {
                return res.data;
            })
        },
        addSchedule: function (roomId, start) {
            return axios.post(this.baseFunctionUrl + "AddSchedule", {
                'roomId': roomId,
                'start': start
            }).then((res) => {
                return res.data;
            })
        },
        addSchedules: function (roomId, start) {
            return axios.post(this.baseFunctionUrl + "AddSchedules", {
                'roomId': roomId,
                'start': start
            }).then((res) => {
                return res.data;
            })
        },
        updateSchedule: function (schedule) {
            return axios.post(this.baseFunctionUrl + "UpdateSchedule", schedule).then((res) => {
                return res.data;
            })
        },
        deleteSchedule: function (scheduleId) {
            return axios.post(this.baseFunctionUrl + "DeleteSchedule", scheduleId).then((res) => {
                return res.data;
            })
        },
        bookSchedule: function (scheduleId, guests) {
            var payload = {
                "scheduleId": scheduleId,
                "email": this.$store.getters.currentUser.email,
                "guests": guests
            };
            return axios.post(this.baseFunctionUrl + "BookSchedule", payload).then((res) => {
                return res.data;
            })
        },
        cancelSchedule: function (scheduleId) {
            var payload = {
                "scheduleId": scheduleId,
                "email": this.$store.getters.currentUser.email
            };
            return axios.post(this.baseFunctionUrl + "CancelSchedule", payload).then((res) => {
                return res.data;
            })
        },
        fetchRoomSchedules: function (roomId, userId, fromDate) {
            return axios.post(this.baseFunctionUrl + "GetRoomSchedules", {
                'roomId': roomId,
                'userId': userId,
                'fromDate': fromDate
            }).then((res) => {
                return res.data;
            })
        },
        isUserDetailsValid(user) {
            var result = true;
            if (user.firstName == undefined || user.firstName == '')
                result = false;
            if (user.lastName == undefined || user.lastName == '')
                result = false;
            if (user.phone == undefined || user.phone == '')
                result = false;

            return result;
        },
        fetchUsers: function () {
            return axios.get(this.baseFunctionUrl + "GetUsers").then((res) => {
                var users = res.data;
                return users;
            })
        },
        fetchUserBookings: function (user) {
            return axios.get(this.baseFunctionUrl + "GetUserBookings/" + user.rowKey).then((res) => {
                var bookingsResult = res.data;
                return bookingsResult;
            })
        },
        fetchUser: function (user) {

            return axios.get(this.baseFunctionUrl + "GetUser/" + user.email).then((res) => {
                var resUser = res.data;
                if (resUser == '[]') {
                    var newUser = {
                        new: true,
                        email: user.email,
                        firstName: user.given_name != undefined ? user.given_name : '',
                        lastName: user.family_name != undefined ? user.family_name : '',

                        verifiedEmail: user.email_verified,
                        roles: "User"
                    }
                    return this.addUpdateUser(newUser).then((res) => {
                        Object.keys(res).forEach((key) => {
                            user[key] = res[key];
                        });

                        return user;
                    })
                } else {

                    Object.keys(res.data).forEach((key) => {
                        user[key] = res.data[key];
                    });

                    return user;
                }
            })
        },
        fetchUser2: function (user) {

            return axios.get(this.baseFunctionUrl + "GetUserById/" + user.rowKey).then((res) => {
                var user = res.data;
                return user;

            })
        },
        addUpdateUser: function (user) {
            return axios.post(this.baseFunctionUrl + "AddOrUpdateUser/", user).then((res) => {
                return res.data;
            })
        },
        getVouchers: function () {

            return axios.get(this.baseFunctionUrl + "voucher").then((res) => {
                var vouchers = res.data;
                return vouchers;

            })
        },
        getCenters() {
            var c = []
            this.fetchVisibleCenters().then(result => {
                result.forEach(center => {

                    c.push({
                        displayName: center.name + " (" + center.zip + ")",
                        name: center.name,
                        address: center.address,
                        address2: center.address2,
                        zip: center.zip,
                        city: center.city,
                        phone: center.contactPhone,
                        email: center.contactEmail,
                        rowKey: center.rowKey,
                        roomId: center.rooms.length > 0 ? center.rooms[0].rowKey : null,
                        scheduleHours: center.rooms[0].scheduleHours,
                        roomWeekHours: center.rooms[0].roomWeekHours
                    })
                });

                store.commit('setCenters', c);
            });
        },

    }
};